import {inject} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateFn, ActivatedRoute, mapToCanActivate
} from '@angular/router';
import {catchError, of} from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginService } from '../login/login.service';
import { AppSettings } from './app.settings';
import { TokenStorageService } from './token-storage.service';
import { HelperService } from './helper.service';
import { NotificationService } from './notification.service';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  
  const loginService = inject(LoginService);
  const router = inject(Router);
  const tokenService = inject(TokenStorageService);
  const helper = inject(HelperService);
  const notification = inject(NotificationService);

  if(AppSettings.BYPASS_ROUTES.includes(state.url)) {
    return true;
  } else if(loginService.isLoggedIn()) {
    if(helper.isRouteAllowed(state.url)) {
      return true;
    } else {
      notification.showError("Module is not allowed for the current role.");
      router.navigate([AppSettings.DEFAULT_ROUTE]);
      return false;
    }
  }else {
    router.navigate([AppSettings.LOGIN_ROUTE]);
    return false;
  }
    
}
